import { useNavigate } from "react-router-dom";
import type { TeamResponse } from "../../types/api";

interface TeamCardProps {
  team: TeamResponse;
  organizationId: string;
  memberCount?: number;
}

export function TeamCard({ team, organizationId, memberCount }: TeamCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/organizations/${organizationId}/teams/${team.id}`);
  };

  return (
    <div
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") handleClick();
      }}
      tabIndex={0}
      className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow cursor-pointer"
    >
      <h3 className="text-xl font-semibold text-gray-900 mb-2">{team.name}</h3>
      {team.description && (
        <p className="text-gray-600 text-sm mb-4 line-clamp-2">{team.description}</p>
      )}
      <div className="flex items-center justify-between text-sm text-gray-500">
        <span>
          {memberCount !== undefined
            ? `${memberCount} ${memberCount === 1 ? "member" : "members"}`
            : "Team"}
        </span>
        <span>Created {new Date(team.createdAt).toLocaleDateString()}</span>
      </div>
    </div>
  );
}
